module.exports = __webpack_public_path__ + "static/media/logo.dfd16048.svg";